import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Input, InputGroup, InputGroupButton, FormFeedback, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, ButtonGroup, Dropdown, DropdownToggle } from 'reactstrap';
import { Link } from 'react-router-dom';


export default class RefundsCancellations extends Component {
  //static propTypes = {testProp: PropTypes.bool.isRequired}

  constructor(props) {
    super(props);

    this.state = {

    };
  }

  render() {
    //const ExampleObject = ( <div></div> );

    return (
    	<FluidContainer fluid>
        <Helmet>
          <title>Refunds and Cancellations - Patterson Maple Farms</title>
        </Helmet>
        <InternalContainer>
	        
      		{/*ExampleObject*/}
      		<h1>Refund & Cancellation Policies</h1>
          <p>We package and ship our items as soon as we can. Please <Link to="/Contact">contact</Link> us with any questions!</p>

          <h3>Order Cancellations</h3>
          <p>
          Orders that you submit online are processed immediately and may not always be cancelled, and you may need to wait until you receive the merchandise in order to return it. Please email or call us if you need to cancel an order.
          </p>

          <h3>Returns</h3>
          <p>
          Once an item of merchandise is delivered to you, you can return that item within 30 days of delivery. To be eligible for a return, your merchandise must be unused and in the same condition that you received it and must be in the original packaging. 
          </p>

          <h3>Shipping</h3>
          <p>
          To initiate a return, please email us at sugarmaster@pattersonmaplefarms.com or call us at (814)-628-3751.  We require a receipt or proof of purchase to accompany your return.

          All returned merchandise should be sent to us at the address we specify through email or by phone.

          For items that are manufactured by another party and resold by Us, please do not send such item back to the manufacturer.

          You are responsible for paying for all shipping costs for your returned item. Shipping costs are non-refundable. If you receive a refund, the cost of any return shipping will be deducted from your refund. You should consider using a trackable shipping service or purchasing shipping insurance for items of value.
          </p>

          <h3>Refunds and Exchanges</h3>
          <p>
          After We have received your valid return, We will send you an email to notify you that We have received your returned item and notify you of the acceptance or rejection of your return.

          If your return is accepted by Us, We will provide one of the following within a reasonable time: an exchange of merchandise for the item returned, a non-transferable merchandise credit, a credit to the payment card or original method of payment used to pay for the item, a check, or another remedy that we determine in good faith is appropriate in the circumstances.
          </p>

          <h3>General</h3>

          <p>If you do not comply with any of the above conditions, We reserve the right to refuse the return or exchange, or to impose different or additional conditions.</p>

        </InternalContainer>
      </FluidContainer>
		);
	}
}

const FluidContainer = styled(Container)` padding: 30px 0 20px 0!important; `;
const InternalContainer = styled(Container)` h1 {color: black!important;}  `;

//const Div_s = styled.div``;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
	display: ${a => a.listSelected ? "block" : "none"};
`;
*/



// WEBPACK FOOTER //
// ./src/pages/RefundsCancellations.js